exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host{min-height:400px;display:block}form{margin:20px 0}.error{margin-top:15px;background-color:rgba(215, 43, 63, .1);border:1px solid rgba(215, 43, 63, .4);border-radius:4px;padding:12px 16px;font-size:13px;font-weight:400;line-height:1.38463;text-align:left;color:#2c2d30}.error .mat-icon{color:#d72b3f;float:left;margin-top:-5px;margin-right:10px}", ""]);

// exports
